export const removeEmptyFields = (formValue: any) => {
  const value = { ...formValue };
  for (const prop in value) {
    if (((!value[prop]) && (typeof value[prop] !== 'boolean') && (value[prop] !== 0 ) || (value[prop] == null))) {
      delete value[prop];
    }
  }
  return value;
};
